import admin from './admin';
import client from './client';
import info from './info';

export default {
  admin,
  client,
  info,
};
